export default __webpack_public_path__ + "static/media/google_drive.1c068158.svg";